import { render } from "./PlaneeritudKohtumisedTegevused.vue?vue&type=template&id=b0eef2fc&scoped=true&ts=true"
import script from "./PlaneeritudKohtumisedTegevused.vue?vue&type=script&lang=ts"
export * from "./PlaneeritudKohtumisedTegevused.vue?vue&type=script&lang=ts"

import "./PlaneeritudKohtumisedTegevused.vue?vue&type=style&index=0&id=b0eef2fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0eef2fc"]])

export default __exports__